'use strict';

{
  const DESCRIPTION_ROOTS = ['#FacetFiltersForm', '#FacetFiltersFormMobile', '#AllergenFilterHero'];

  const queryInRoots = (selector) =>
    DESCRIPTION_ROOTS.flatMap((root) => [...document.querySelectorAll(`${root} ${selector}`)]);

  const closestInRoots = (element, selector) => {
    if (!element?.closest) {
      return null;
    }

    for (const root of DESCRIPTION_ROOTS) {
      const match = element.closest(`${root} ${selector}`);
      if (match) {
        return match;
      }
    }

    return null;
  };

  const closeAllDesktop = (exceptToggle) => {
    queryInRoots('.filter-description__toggle[aria-expanded="true"]').forEach((toggle) => {
      if (exceptToggle && toggle === exceptToggle) {
        return;
      }

      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.hidden = true;
      }
    });
  };

  const toggleDesktopPanel = (toggle) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) {
      return;
    }

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    } else {
      closeAllDesktop(toggle);
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  };

  const resetMobileToggle = (toggle) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.hidden = true;
    }
  };

  const toggleMobilePanel = (toggle) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) {
      return;
    }

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      resetMobileToggle(toggle);
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  };

  const bindDesktopToggle = (toggle) => {
    if (toggle.dataset.filterDescriptionBound === 'true') {
      return;
    }

    toggle.dataset.filterDescriptionBound = 'true';
    toggle.addEventListener('click', () => {
      toggleDesktopPanel(toggle);
    });
  };

  const bindMobileToggle = (toggle) => {
    if (toggle.dataset.filterDescriptionMobileBound === 'true') {
      return;
    }

    toggle.dataset.filterDescriptionMobileBound = 'true';

    toggle.addEventListener('click', () => {
      toggleMobilePanel(toggle);
    });

    toggle.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      if (event.key === ' ') {
        event.preventDefault();
      }

      toggleMobilePanel(toggle);
    });
  };

  const bindMobileDetailsReset = () => {
    queryInRoots('.mobile-facets__details').forEach((details) => {
      if (details.dataset.filterDescriptionDetailsBound === 'true') {
        return;
      }

      details.dataset.filterDescriptionDetailsBound = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) {
          return;
        }

        details.querySelectorAll('.mobile-facets__filter-description-toggle').forEach((toggle) => {
          resetMobileToggle(toggle);
        });
      });
    });
  };

  const bindAll = () => {
    queryInRoots('.filter-description__toggle').forEach(bindDesktopToggle);
    queryInRoots('.mobile-facets__filter-description-toggle').forEach(bindMobileToggle);
    bindMobileDetailsReset();
  };

  document.addEventListener('click', (event) => {
    if (closestInRoots(event.target, '.filter-description__toggle')) {
      return;
    }

    if (!closestInRoots(event.target, '.filter-description')) {
      closeAllDesktop();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllDesktop();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  ['main-collection-filters', 'AllergenFilterHero'].forEach((rootId) => {
    const root = document.getElementById(rootId);
    if (!root) {
      return;
    }

    const observer = new MutationObserver(() => {
      bindAll();
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });
  });
}
